import { render } from "./Certifications.vue?vue&type=template&id=07e9ca61&scoped=true"
import script from "./Certifications.vue?vue&type=script&lang=js"
export * from "./Certifications.vue?vue&type=script&lang=js"

import "./Certifications.vue?vue&type=style&index=0&id=07e9ca61&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07e9ca61"]])

export default __exports__